import * as actionTypes from '../actions'

const initialState = {
  cities: []
}

const cityReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.GET_CITIES: {
      return {
        ...state,
        cities: action.payload.cities,
      }
    }

    default: {
      return state
    }
  }
}

export default cityReducer
